module.exports = __webpack_public_path__ + "img/sentry.b655852f.svg";